/* Product Related Blog — deferred external asset.
 * Extracted from sections/product-related-blog.liquid inline script to avoid
 * parser-blocking inline HTML-in-JS and to allow browser caching.
 * Initializes every [data-prb-section] container from its data attributes.
 */
(function () {
  'use strict';

  var STOREFRONT_API_TOKEN = 'c766816796b591138cecf3dccc94c5de';
  var STOREFRONT_API_URL = 'https://minumancom.myshopify.com/api/2024-10/graphql.json';

  var CACHE_KEY_PREFIX = 'prb_all_articles_';
  var CACHE_EXPIRY_MS = 1000 * 60 * 60 * 1;
  var MAX_ARTICLES_TO_SHOW = 8;

  function parseJsonAttribute(value, fallback) {
    if (value == null || value === '') {
      return fallback;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function initSection(rootEl) {
    if (!rootEl || rootEl.dataset.prbInit === 'true') {
      return;
    }
    rootEl.dataset.prbInit = 'true';

    var sectionId = rootEl.dataset.sectionId;
    var blogHandle = rootEl.dataset.blogHandle || 'news';
    var currentProductId = rootEl.dataset.productId || '';
    var productType = rootEl.dataset.productType || '';
    var currentProductTypeTag = productType ? 'type:' + productType : '';
    var manualArticleGids = parseJsonAttribute(rootEl.dataset.manualGids, []);

    var settings = {
      slidesDesktop: parseFloat(rootEl.dataset.slidesDesktop || '3'),
      slidesMobile: parseFloat(rootEl.dataset.slidesMobile || '1'),
      showDate: rootEl.dataset.showDate === 'true',
      showExcerpt: rootEl.dataset.showExcerpt === 'true',
      showViewAll: rootEl.dataset.showViewAll === 'true',
      viewAllLogicCount: 6,
    };

    var carouselEl = rootEl.querySelector('#prb-' + sectionId) || rootEl.querySelector('.prb-carousel');
    if (!carouselEl) {
      return;
    }
    var trackEl = carouselEl.querySelector('.prb-track');
    var viewAllBtn = rootEl.querySelector('a.section__action-link');
    if (!trackEl) {
      return;
    }

    function getQuery(cursor) {
      var after = cursor ? ', after: "' + cursor + '"' : '';
      return (
        '{\n' +
        '  blog(handle: "' +
        blogHandle +
        '") {\n' +
        '    articles(first: 250' +
        after +
        ', reverse: true) {\n' +
        '      pageInfo {\n' +
        '        hasNextPage\n' +
        '        endCursor\n' +
        '      }\n' +
        '      edges {\n' +
        '        node {\n' +
        '          id\n' +
        '          title\n' +
        '          handle\n' +
        '          onlineStoreUrl\n' +
        '          publishedAt\n' +
        '          tags\n' +
        '          image {\n' +
        '            url(transform: {maxWidth: 800, maxHeight: 450, crop: CENTER})\n' +
        '            altText\n' +
        '            width\n' +
        '            height\n' +
        '          }\n' +
        '          excerpt(truncateAt: 120)\n' +
        '        }\n' +
        '      }\n' +
        '    }\n' +
        '  }\n' +
        '}'
      );
    }

    async function fetchAllArticles(cursor, accumulatedArticles) {
      cursor = cursor || null;
      accumulatedArticles = accumulatedArticles || [];
      var response = await fetch(STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN,
        },
        body: JSON.stringify({ query: getQuery(cursor) }),
      });

      if (!response.ok) {
        return [];
      }

      var data = await response.json();
      if (!data.data || !data.data.blog) {
        return [];
      }

      var articles = data.data.blog.articles.edges.map(function (edge) {
        return edge.node;
      });
      var newAccumulatedArticles = accumulatedArticles.concat(articles);
      var pageInfo = data.data.blog.articles.pageInfo;

      if (pageInfo.hasNextPage && pageInfo.endCursor) {
        return fetchAllArticles(pageInfo.endCursor, newAccumulatedArticles);
      }
      return newAccumulatedArticles;
    }

    async function getAndCacheAllArticles() {
      var articles = await fetchAllArticles();
      var cacheData = { timestamp: Date.now(), articles: articles };
      try {
        localStorage.setItem(CACHE_KEY_PREFIX + blogHandle, JSON.stringify(cacheData));
      } catch (e) {}
      return articles;
    }

    async function getArticles() {
      var cacheKey = CACHE_KEY_PREFIX + blogHandle;
      var cachedData = null;
      try {
        cachedData = JSON.parse(localStorage.getItem(cacheKey));
      } catch (e) {}
      if (cachedData && Date.now() - cachedData.timestamp < CACHE_EXPIRY_MS) {
        return cachedData.articles;
      }
      return getAndCacheAllArticles();
    }

    function escapeAttr(value) {
      return String(value == null ? '' : value).replace(/"/g, '&quot;');
    }

    function createarticleCardHTML(article) {
      var pubDate = new Date(article.publishedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

      var imageHtml = '';
      if (article.image) {
        var alt = article.image.altText || article.title;
        imageHtml =
          '<div class="article-image">' +
          '<img src="' +
          article.image.url +
          '" alt="' +
          escapeAttr(alt) +
          '" loading="lazy" width="' +
          (article.image.width || 800) +
          '" height="' +
          (article.image.height || 450) +
          '">' +
          '</div>';
      }

      var dateHtml = settings.showDate ? '<p class="article-date">' + pubDate + '</p>' : '';
      var excerptHtml =
        settings.showExcerpt && article.excerpt ? '<p class="article-excerpt">' + article.excerpt + '</p>' : '';

      return (
        '<div class="prb-cell"><div class="article-grid-item">' +
        '<a href="' +
        article.onlineStoreUrl +
        '" class="article-link">' +
        imageHtml +
        '<div class="article-content"><h3 class="article-title">' +
        article.title +
        '</h3>' +
        dateHtml +
        excerptHtml +
        '</div></a></div></div>'
      );
    }

    function createPulsePlaceholderHTML() {
      return (
        '<div class="prb-cell is-loading"><div class="article-grid-item">' +
        '<div class="pulse-image"></div><div class="pulse-content">' +
        '<div class="pulse-line"></div><div class="pulse-line w-75"></div><div class="pulse-line w-50"></div>' +
        '</div></div></div>'
      );
    }

    function setupSlider(totalMatches) {
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var slidesToShow = isDesktop ? settings.slidesDesktop : settings.slidesMobile;
      var enableSlider = totalMatches > slidesToShow;

      carouselEl.style.setProperty('--cols', Math.max(1, Math.floor(slidesToShow)));
      carouselEl.classList.toggle('is-slider', enableSlider);
      rootEl.classList.toggle('slider-active', enableSlider);

      if (!enableSlider) {
        if (trackEl._flkty && trackEl._flkty.destroy) {
          trackEl._flkty.destroy();
          trackEl._flkty = null;
        }
        return;
      }

      function initFlickity() {
        if (typeof Flickity === 'undefined') {
          return false;
        }
        if (trackEl._flkty && trackEl._flkty.destroy) {
          trackEl._flkty.destroy();
        }
        carouselEl.style.setProperty('--slides', slidesToShow);
        var flkty = new Flickity(trackEl, {
          cellSelector: '.prb-cell',
          contain: true,
          wrapAround: false,
          prevNextButtons: true,
          pageDots: false,
          imagesLoaded: true,
          percentPosition: true,
        });
        trackEl._flkty = flkty;
        return true;
      }

      function loadFlickity(cb) {
        if (typeof Flickity !== 'undefined') {
          return cb();
        }
        var jsId = 'flickity-js';
        if (!document.getElementById(jsId)) {
          var s = document.createElement('script');
          s.id = jsId;
          s.src = 'https://cdn.jsdelivr.net/npm/flickity@2/dist/flickity.pkgd.min.js';
          s.defer = true;
          s.onload = cb;
          document.head.appendChild(s);
        } else {
          document.getElementById(jsId).addEventListener('load', cb);
        }
      }

      loadFlickity(initFlickity);
    }

    async function main() {
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var slides = isDesktop ? settings.slidesDesktop : settings.slidesMobile;
      var placeholderHtml = '';
      for (var i = 0; i < Math.floor(slides); i++) {
        placeholderHtml += createPulsePlaceholderHTML();
      }
      trackEl.innerHTML = placeholderHtml;
      rootEl.style.display = 'block';

      var allArticles = await getArticles();
      if (!allArticles || allArticles.length === 0) {
        rootEl.style.display = 'none';
        return;
      }

      var matchedArticles = [];
      var seenArticleIds = {};
      var apiArticlesMap = {};
      allArticles.forEach(function (article) {
        apiArticlesMap[article.id] = article;
      });

      if (manualArticleGids.length > 0) {
        for (var g = 0; g < manualArticleGids.length; g++) {
          var gid = manualArticleGids[g];
          if (apiArticlesMap[gid]) {
            matchedArticles.push(apiArticlesMap[gid]);
            seenArticleIds[gid] = true;
          }
        }
      }

      if (currentProductTypeTag) {
        for (var a = 0; a < allArticles.length; a++) {
          var article = allArticles[a];
          if (!seenArticleIds[article.id] && article.tags.indexOf(currentProductTypeTag) !== -1) {
            matchedArticles.push(article);
          }
        }
      }

      if (matchedArticles.length === 0) {
        rootEl.style.display = 'none';
        return;
      }

      var finalArticles = matchedArticles.slice(0, MAX_ARTICLES_TO_SHOW);
      var finalHtml = '';
      for (var f = 0; f < finalArticles.length; f++) {
        finalHtml += createarticleCardHTML(finalArticles[f]);
      }
      trackEl.innerHTML = finalHtml;

      if (viewAllBtn && settings.showViewAll && matchedArticles.length > settings.viewAllLogicCount) {
        viewAllBtn.style.display = 'flex';
      }

      setupSlider(finalArticles.length);
      window.addEventListener('resize', function () {
        setupSlider(finalArticles.length);
      });
    }

    main();
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-prb-section]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('[data-prb-section]')
      : null;
    if (section) {
      section.dataset.prbInit = '';
      initSection(section);
    } else {
      initAll();
    }
  });
})();
